import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "suggest-input" }
const _hoisted_2 = {
  key: 0,
  class: "suggest-input__label"
}
const _hoisted_3 = { class: "suggest-input__field-wrapper" }
const _hoisted_4 = ["value", "placeholder", "disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "suggest-input__options"
}
const _hoisted_7 = ["onMousedown"]

import { ref, watch } from 'vue';
import Mdi from './Mdi.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SuggestInput',
  props: {
    modelValue: {},
    options: {},
    placeholder: {},
    label: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isOpen = ref(false);
const highlightedOptionIndex = ref(0);

/**
 * 候補一覧を開く
 */
const openOptions = (): void => {
  if (props.disabled) {
    return;
  }
  isOpen.value = true;
  highlightedOptionIndex.value = 0;
};

/**
 * 候補一覧を閉じる
 */
const closeOptions = (): void => {
  isOpen.value = false;
  highlightedOptionIndex.value = -1;
};

/**
 * 候補一覧を閉じる(遅延)
 */
const closeOptionsDelayed = (): void => {
  window.setTimeout(() => {
    closeOptions();
  }, 120);
};

/**
 * 候補値を選択する
 * @param optionValue - 選択した候補値
 */
const selectOption = (optionValue: string): void => {
  emit('update:modelValue', optionValue);
  closeOptions();
};

/**
 * 入力変更を処理する
 * @param event - 入力イベント
 */
const onInput = (event: Event): void => {
  emit('update:modelValue', (event.target as HTMLInputElement).value);
  openOptions();
};

/**
 * 入力欄のキー入力を処理する
 * @param event - キーボードイベント
 */
const onKeydown = (event: KeyboardEvent): void => {
  if (props.options.length === 0) {
    return;
  }

  if (event.key === 'ArrowDown') {
    event.preventDefault();
    if (!isOpen.value) {
      openOptions();
      highlightedOptionIndex.value = 0;
      return;
    }
    highlightedOptionIndex.value = Math.min(highlightedOptionIndex.value + 1, props.options.length - 1);
    return;
  }

  if (event.key === 'ArrowUp') {
    event.preventDefault();
    if (!isOpen.value) {
      openOptions();
      highlightedOptionIndex.value = props.options.length - 1;
      return;
    }
    highlightedOptionIndex.value = Math.max(highlightedOptionIndex.value - 1, 0);
    return;
  }

  if (event.key === 'Enter' && isOpen.value) {
    if (highlightedOptionIndex.value >= 0 && highlightedOptionIndex.value < props.options.length) {
      event.preventDefault();
      selectOption(props.options[highlightedOptionIndex.value]);
    }
    return;
  }

  if (event.key === 'Escape') {
    closeOptions();
  }
};

watch(
  () => props.options,
  (nextOptions) => {
    if (nextOptions.length === 0) {
      highlightedOptionIndex.value = -1;
      return;
    }
    highlightedOptionIndex.value = Math.min(Math.max(highlightedOptionIndex.value, 0), nextOptions.length - 1);
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label != null && _ctx.label !== '')
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        value: _ctx.modelValue,
        class: "suggest-input__input",
        type: "text",
        placeholder: _ctx.placeholder,
        disabled: _ctx.disabled,
        onFocus: openOptions,
        onBlur: closeOptionsDelayed,
        onInput: onInput,
        onKeydown: onKeydown
      }, null, 40, _hoisted_4),
      _createElementVNode("button", {
        type: "button",
        class: "suggest-input__toggle",
        disabled: _ctx.disabled,
        onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
        onClick: openOptions
      }, [
        _createVNode(Mdi, { icon: "arrow_drop_down" })
      ], 40, _hoisted_5),
      (isOpen.value && _ctx.options.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (optionValue, optionIndex) => {
              return (_openBlock(), _createElementBlock("button", {
                key: `suggest-input-option-${optionValue}`,
                type: "button",
                class: _normalizeClass(["suggest-input__option", { 'suggest-input__option--active': highlightedOptionIndex.value === optionIndex }]),
                onMousedown: _withModifiers(($event: any) => (selectOption(optionValue)), ["prevent"])
              }, _toDisplayString(optionValue), 43, _hoisted_7))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})